import React from 'react';
import { useNavigate } from 'react-router-dom';

const CompetitionHeader = ({ request }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-8">
      <div className="bg-gradient-to-r from-[#E96A37] to-orange-600 rounded-2xl p-8 text-white shadow-xl">
        <div className="flex items-center space-x-4 mb-4">
          <button
            onClick={() => navigate('/organization/competition-requests')}
            className="p-2 text-white/80 hover:text-white hover:bg-white/20 rounded-lg transition-colors duration-200"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <div className="flex-1">
            <h1 className="text-3xl font-bold">{request.title}</h1>
            <p className="text-white/90 mt-2">Competition Request Details</p>
          </div>
          <div className="flex items-center space-x-3">
            <span className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold border-2 border-white/30 bg-white/20 text-white`}>
              {request.status?.toUpperCase()}
            </span>
            <span className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-bold bg-white/20 text-white`}>
              {request.requestType?.replace('_', ' ')?.toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompetitionHeader; 